import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Flex,
  Icon,
  Text,
  colors,
} from 'react-orange-ui';

const Container = styled.div`
  display: ${props => props.collapse ? 'block' : 'none'};
  width: 100%;
  background-color: ${colors.grey6};
  padding: 1rem;
  margin-top: 0.5rem;
`;

const StyledFlex = styled(Flex)`
  width: 100%;
`;

const Card = ({ caption, collapse }) => (
  <Container collapse={collapse} id="helpCard">
    <Text id="helpMessage">
      { caption }
    </Text>
  </Container>
);

export default class TitleWithCard extends Component {
  state = {
    collapse: false,
    color: 'blue',
  };

  /**
   * Collapse the helper card on click
   * Call the onIconClick function when specified
   */
  handleClick = () => {
    const { collapse } = this.state;
    const { onIconClick } = this.props;

    this.setState({ collapse: !collapse }, () => {
      if (!collapse && onIconClick) {
        onIconClick();
      }
    });
  };

  setColor = (color) => { this.setState({ color }); };

  render() {
    const { collapse, color } = this.state;
    const {
      title, hint, idLabel, idIcon,
    } = this.props;

    return (
      <Flex alignItems="flex-start" flexDirection="column">
        <StyledFlex justifyContent="space-between">
          <Text size="l" bold id={idLabel}>
            {title}
          </Text>
          <Icon
            id={idIcon}
            icon="assistance"
            width={24}
            height={24}
            color={color}
            onMouseDown={() => this.setColor('orange')}
            onMouseUp={() => this.setColor('black')}
            onMouseEnter={() => this.setColor('black')}
            onMouseLeave={() => this.setColor('blue')}
            onClick={this.handleClick}
            style={{ cursor: 'pointer' }}
          />
        </StyledFlex>
        <Card collapse={collapse} caption={hint} />
      </Flex>
    );
  }
}

TitleWithCard.defaultProps = {
  hint: '',
  idLabel: 'stepTitle',
  idIcon: 'helpIcon',
  onIconClick: undefined,
};

TitleWithCard.propTypes = {
  /** Title label */
  title: PropTypes.string.isRequired,
  /** The hints to help the user */
  hint: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  /** String label identifier */
  idLabel: PropTypes.string,
  /** String icon identifier */
  idIcon: PropTypes.string,
  /** Function callback on help icon click */
  onIconClick: PropTypes.func,
};

Card.propTypes = {
  /** The hints to help the user */
  caption: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
  /** The var to know if the hint should be collapse */
  collapse: PropTypes.bool.isRequired,
};
